<div [id]="id" bsModal #modalControl="bs-modal"  [config]="config" class="modal fade" role="dialog" (onHidden)="onHidden()">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <a (click)="HideModalDialog($event)"> 
          <img *ngIf='showClose' src='./assets/img/svg/close_icon.svg' class="pull-right close-img" data-dismiss="modal" aria-label="Close"></a>
        <h2 id="title" class="title text-green text-center">{{title}}</h2>
        <p id="subtitle" class="text-center">{{subtitle}}</p>
        <div class="row text-center">
            <div class="divider-line div-line-marg-top"></div>
        </div>
      </div>
      <ng-content select=".modal-body"></ng-content>
      <ng-content select=".modal-footer"></ng-content>
    </div>
  </div>
</div>
